export default "__VITE_ASSET__BDs5__jp__"